<template>
  <div class="template">
    <div class="search">
      <div>
        <Input v-model="search.search" placeholder="关键字" style="width: 310px" icon="ios-search"></Input>
        <Select
          v-model="search.certificates_id"
          filterable
          clearable
          :remote-method="searchCertificates"
          :loading="diyDom.certLoading"
          style="width: 200px; margin: 0 10px"
          placeholder="输入关键字搜索证书"
        >
          <Option
            v-for="(item, index) in apiData.searchCerts"
            :value="item.id"
            :label="item.title"
            :key="index"
          ></Option>
        </Select>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <div>
        <Button
          type="primary"
          icon="ios-cloud-download"
          style="width: 90px; margin: 0 10px"
          @click="diyDom.showLicense = true"
        >
          导入
        </Button>
        <Button type="primary" icon="ios-add" style="width: 90px" @click="diyDom.showModal = true">添加</Button>
      </div>
    </div>
    <div class="filter">
      <div class="filter-item">
        <span class="title">开始时间</span>
        <DatePicker v-model="search.start_date" style="width: 200px" placeholder="请选择开始时间"></DatePicker>
      </div>
      <div class="filter-item">
        <span class="title">结束时间</span>
        <DatePicker v-model="search.end_date" style="width: 200px" placeholder="请选择结束时间"></DatePicker>
      </div>
      <div class="filter-item">
        <Button type="primary" style="width: 90px" @click="searchFn">搜索</Button>
        <Button style="margin-left: 10px; width: 90px" @click="clearFn">清空</Button>
      </div>
    </div>
    <div style="display: flex; justify-content: right; align-items: center; cursor: pointer" @click="downloadFn">
      <Icon color="#2d8cf0" type="ios-cloud-download" />
      <a style="margin-left: 5px">证书导出</a>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
    <add-license
      v-model="diyDom.showModal"
      :id="diyData.id"
      :isEdit="diyDom.isEdit"
      :certs="apiData.certs"
      @on-success="updateLicenese"
    ></add-license>
    <!-- 导入证书 -->
    <import-license v-model="diyDom.showLicense" @on-success="getTableList"></import-license>
  </div>
</template>

<script>
import * as apiCertificates from '@/api/certificates'
import addLicense from './add-license.vue'
import ImportLicense from './import-license.vue'
import { getLoaclDate } from '@/libs/util'
import downloadBlob from '@/utils/downloadBlob'
export default {
  name: 'recordList',
  components: {
    addLicense,
    ImportLicense
  },
  data () {
    return {
      query: {},
      search: {
        search: '',
        start_date: '',
        end_date: '',
        certificates_id: '',
        page: 1
      },
      diyDom: {
        showModal: false,
        isEdit: false,
        showPhoto: false,
        showLicense: false,
        certLoading: false
      },
      diyData: {
        id: '',
        columns: [
          {
            title: 'ID',
            width: 60,
            fixed: 'left',
            render: (h, params) => {
              return h('div', params.index + 1)
            }
          },
          {
            title: '免冠照/姓名',
            key: 'name',
            width: 200,
            fixed: 'left',
            render: (h, params) => {
              return h(
                'div',
                {
                  style: {
                    display: 'flex',
                    alignItems: 'center'
                  }
                },
                [
                  h('img', {
                    attrs: {
                      src: params.row.licence_photo_url
                    },
                    style: {
                      width: '60px',
                      margin: '5px'
                    }
                  }),
                  h('div', params.row.name)
                ]
              )
            }
          },
          {
            title: '性别',
            key: 'gender_label',
            width: 90
          },
          {
            title: '证件号',
            key: 'id_card',
            width: 180
          },
          {
            title: '证书名称',
            key: 'certificates_name',
            width: 180
          },
          {
            title: '证书编号',
            key: 'certificate_no',
            width: 180
          },
          {
            title: '专业类型',
            key: 'specialty',
            width: 180
          },
          {
            title: '发证时间',
            key: 'date_of_issue',
            width: 120
          },
          {
            title: '证书生成状态',
            key: 'certificates_image_thumb',
            render: (h, params) => {
              return h('div', params.row.certificates_image_thumb == '' ? '未生成' : '已生成')
            },
            width: 120
          },
          {
            title: '状态',
            key: 'status_label',
            width: 120
          },
          {
            title: '创建时间',
            key: 'created_at',
            width: 180
          },
          {
            title: '操作',
            fixed: 'right',
            width: 130,
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.diyDom.isEdit = true
                        this.diyData.id = params.row.id
                        this.diyDom.showModal = true
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.diyData.id = params.row.id
                        this.updateLicenese()
                      }
                    }
                  },
                  '更新证书'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0',
                      display: params.row.certificates_image_thumb ? 'inline' : 'none'
                    },
                    on: {
                      click: () => {
                        let a = document.createElement('a')
                        a.href = `${params.row.certificates_image_thumb}?t=${new Date().getTime()}`
                        a.target = '_blank'
                        document.body.appendChild(a)
                        a.click()
                        document.body.removeChild(a)
                      }
                    }
                  },
                  '预览'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: 'red'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '提示',
                          content: '请确认是否删除当前数据？',
                          onOk: () => {
                            apiCertificates.apiCertificatesUsersDetele(params.row.id).then(res => {
                              this.$Message.success('已删除')
                              this.getTableList()
                            })
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        per_page: 0,
        tableList: [],
        certs: [], // 证书列表
        searchCerts: [] // 搜索的证书列表
      }
    }
  },
  methods: {
    // 获取表格数据
    getTableList () {
      this.$store.commit('setSpinShow', true)
      this.search.start_date = getLoaclDate(this.search.start_date)
      this.search.end_date = getLoaclDate(this.search.end_date)
      apiCertificates
        .apiCertificatesUsersList({ ...this.search })
        .then(res => {
          const { data, meta } = res
          this.apiData.tableList = data
          this.apiData.per_page = meta.pagination.per_page
          this.apiData.total = meta.pagination.total
          this.apiData.certs = meta.certs.map(item => {
            return {
              ...item,
              id: item.id + ''
            }
          })
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    // 分页
    pageChange (e) {
      this.search.page = e
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.page = 1
      this.getTableList()
    },
    // 清空
    clearFn () {
      this.search = {
        search: '',
        start_date: '',
        end_date: '',
        certificates_id: '',
        page: 1
      }
      this.getTableList()
    },

    // 证书搜索
    searchCertificates (query) {
      if (query !== '') {
        this.diyDom.certLoading = true
        apiCertificates
          .apiCertificatesSearch({
            search: query
          })
          .then(res => {
            this.apiData.searchCerts = res.data
          })
          .finally(() => this.diyDom.certLoading = false)
      }
    },

    // 下载
    downloadFn () {
      this.$Modal.confirm({
        title: '提示',
        content: '请确认是否导出证书？',
        onOk: () => {
          this.$store.commit('setSpinShow', true)
          this.search.start_date = getLoaclDate(this.search.start_date)
          this.search.end_date = getLoaclDate(this.search.end_date)
          apiCertificates
            .apiCertificatesExport({ ...this.search, t: new Date().getTime() })
            .then(res => {
              downloadBlob(res)
            })
            .finally(() => this.$store.commit('setSpinShow', false))
        }
      })
    },
    // 编辑完成更新证书
    updateLicenese () {
      this.$store.commit('setSpinShow', true)
      apiCertificates
        .apiCertificatesUsersUpdate(this.diyData.id)
        .then(res => {
          this.$Message.success('用户证书更新成功')
        })
        .finally(() => {
          this.$store.commit('setSpinShow', false)
          this.getTableList()
        })
    }
  },
  watch: {
    'diyDom.showModal' (val) {
      if (!val) {
        this.diyDom.isEdit = false
      }
    }
  },
  mounted () {
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
